import { MapOptions } from "google-map-react"

type extendedMapOptions = MapOptions & { mapId?: string }
export const mapOptions: extendedMapOptions = {
  // mapId: "5ce3117565d8f466",
  fullscreenControl: false,
}
